import React, {useEffect} from "react";
import TabComponent from "./TabComponent";
import ShipmentBoardComponent from "./ShipmentDashboard/ShipmentBoardComponent";
import {PickupActions} from "../../Store/Pickup/Slice";
import SwitchComponent from "../Shared/FilterShipment/SwitchComponent";
import NewShipmentComponent from "./NewShipment/NewShipmentComponent";
import {useDispatch, useSelector} from "react-redux";
import {Container} from "reactstrap";
import {RootState} from "../../Store/Reducers";
import ManagementReportComponent from './ManagementReport/ManagementReportComponent';

const DashboardComponent = () => {

  const dispatch = useDispatch();

  const {CompanyReducer : {company_selected, branch_selected}} = useSelector((state: RootState) => state);

  useEffect(()=> {
    if (company_selected || branch_selected) {
      dispatch(PickupActions.getPickups());
    }
  },[dispatch, company_selected, branch_selected]);

  return(
    <>
      <div className="d-sm-none d-block">
        <TabComponent/>
      </div>

      <div className="d-none d-sm-block">
        <Container fluid>
          <Container className="d-flex justify-content-end" fluid>
            <ManagementReportComponent/>
            <NewShipmentComponent/>
            <SwitchComponent/>
          </Container>
          <ShipmentBoardComponent/>
        </Container>
      </div>
    </>
  );
};

export default DashboardComponent;
